var render = function render(){var _vm=this,_c=_vm._self._c;return _c('canvas',{ref:"canvas",staticStyle:{"max-width":"100%"}})
}
var staticRenderFns = []

export { render, staticRenderFns }